import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import NxtTopBar from '../../../basic/nxt-top-bar';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import {
  yellowBaseColor,
  blackLikeBackground
} from '../../../../constants/theme-colors';
import ListItem from '@material-ui/core/ListItem';
import { Avatar, withStyles, Menu, MenuItem } from '@material-ui/core';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import ListItemText from '@material-ui/core/ListItemText';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles(theme => ({
  bottomNav: {
    bottom: '0',
    position: 'fixed',
    width: '100%',
    marginLeft: '0em',

    zIndex: theme.zIndex.bottomNav
  },
  avatarWrapper: {
    //backgroundColor: yellowBaseColor,
    color: blackLikeBackground,
    paddingTop: theme.spacing(2),
    //borderBottom: '1px solid RGB(225,225,225)',
    marginTop: '2rem'
  },
  avatarContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  avatarStyle: {
    height: '80px',
    width: '80px',
    marginTop: '1rem',
    background: 'rgb(0 0 0 / 8%)'
  },
  personIcon: {
    fontSize: '2.5em',
    color: '#A6ACAF'
  },
  accountInfo: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    fontFamily: 'Roboto,Helvetica,Arial,sans-serif',
    marginTop: '-.8rem',
    marginBottom: '1rem'
  },
  optionHeader: {
    color: 'black',
    marginLeft: '1rem',
    fontWeight: 600
  },
  accountOptions: {
    //background: 'rgb(0 0 0 / 8%)',
    borderBottom: '1px solid rgb(0 0 0 / 10%)',
    borderTop: '1px solid rgb(0 0 0 / 10%)',
    height: '5rem',
    '& .MuiTypography-body1': {
      fontSize: '1rem',
      fontWeight: 400
      //color: '#424949'
    }
  },
  optionArrowIcon: {
    fontSize: '1rem',
    color: '#A6ACAF'
  },
  titleText: {
    fontSize: '.9rem',
    fontWeight: 500,
    color: 'rgb(127,129,149)'
  },
  valueText: {
    fontSize: '1.1rem',
    fontWeight: 400,
    color: '#000000'
  },
  iconEdit: {
    height: '20px'
  },
  headerTextColor: {
    color: 'black'
  }
}));

const TakeoutUserProfile = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation(['common']);
  const loggedInUser = useSelector(state => state.appState.registeredUser.data);

  const profileData = [
    { title: t('firstName'), value: loggedInUser.firstName },
    { title: t('lastName'), value: loggedInUser.lastName },
    { title: t('Email'), value: loggedInUser.email },
    { title: t('Phone'), value: loggedInUser.phone },
    { title: t('dob'), value: loggedInUser.dob },
    { title: t('Gender'), value: loggedInUser.gender }
  ];

  return (
    <div>
      <NxtTopBar children={t('User Profile')} isEditIcon={true} editLink={'/customer-registration'} />

      <List className={classes.avatarWrapper}>
        <ListItem className={classes.avatarContainer}>
          <Avatar className={classes.avatarStyle}>
            <PersonOutlineIcon className={classes.personIcon} />
          </Avatar>
        </ListItem>

        <ListItem className={classes.accountInfo}>
          {/* <EditIcon color='primary' className={classes.iconEdit} />
          <p className={clsx(classes.titleText, classes.headerTextColor)}>
            Change profile picture
          </p> */}
        </ListItem>

        {profileData.map((e, i) => (
          <ListItem className={classes.accountOptions} key={i}>
            <ListItemText
              classes={{
                primary: classes.titleText,
                secondary: classes.valueText
              }}
              primary={e.title}
              secondary={e.value}
            />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default TakeoutUserProfile;
